<section class="flex flex-col h-full max-h-full">
  <div class="flex-1 flex w-full">
    <app-lista-asignados class="block min-w-72 2xl:min-w-[400px]" [turnosAsignados]="listaAsignados()"></app-lista-asignados>
    <app-turno-actual class="flex-1" [turno]="turnoActual()" [turno2]="segundoturno()" [turno3]="tercerTurno()" [sala]="sala()" [multimedia1]="multimedia()" [multimedia2]="multimedia2()"></app-turno-actual>
  </div>
</section>
